<template>
  <div class="container-help" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" @click-left="closeWeb" />
        <!-- 主播等级分成规则 -->
        <span class="tit-left">{{ $t('lang.LevelRatio.k010') }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="table">
        <tr>
          <th class="level th1">
            <div>
              {{ $t('lang.BaseCommon.k052') }}
            </div>
          </th>
          <th class="rate">
            <div>
              {{ $t('lang.LevelRatio.k007') }}
            </div>
          </th>
          <th class="rate">
            <div>
              {{ $t('lang.LevelRatio.k008') }}
            </div>
          </th>
          <th class="rate th4">
            <div>
              {{ $t('lang.LevelRatio.k009') }}
              <span>(beans/min)</span>
            </div>
          </th>
        </tr>

        <!-- 巴西地区 -->
        <template v-if="code == 'BR'">
          <tr>
            <td class="level">L0</td>
            <td class="rate">0min</td>
            <td class="rate">50%</td>
            <td class="rate">280</td>
          </tr>
          <tr>
            <td class="level">L1</td>
            <td class="rate">10mins</td>
            <td class="rate">52%</td>
            <td class="rate">290</td>
          </tr>
          <tr>
            <td class="level">L2</td>
            <td class="rate">30mins</td>
            <td class="rate">54%</td>
            <td class="rate">300</td>
          </tr>
          <tr>
            <td class="level">L3</td>
            <td class="rate">50mins</td>
            <td class="rate">56%</td>
            <td class="rate">310</td>
          </tr>
          <tr>
            <td class="level">L4</td>
            <td class="rate">70mins</td>
            <td class="rate">58%</td>
            <td class="rate">320</td>
          </tr>
          <tr>
            <td class="level">L5</td>
            <td class="rate">90mins</td>
            <td class="rate">60%</td>
            <td class="rate">330</td>
          </tr>
          <tr>
            <td class="level">L6</td>
            <td class="rate">120mins</td>
            <td class="rate">62%</td>
            <td class="rate">340</td>
          </tr>
          <tr>
            <td class="level">L7</td>
            <td class="rate">180mins</td>
            <td class="rate">65%</td>
            <td class="rate">350</td>
          </tr>
        </template>

        <!-- 其他地区 -->
        <template v-else>
          <tr>
            <td class="level">L0</td>
            <td class="rate">0mins</td>
            <td class="rate">50%</td>
            <td class="rate">180</td>
          </tr>
          <tr>
            <td class="level">L1</td>
            <td class="rate">10mins</td>
            <td class="rate">52%</td>
            <td class="rate">190</td>
          </tr>
          <tr>
            <td class="level">L2</td>
            <td class="rate">30mins</td>
            <td class="rate">54%</td>
            <td class="rate">200</td>
          </tr>
          <tr>
            <td class="level">L3</td>
            <td class="rate">50mins</td>
            <td class="rate">56%</td>
            <td class="rate">210</td>
          </tr>
          <tr>
            <td class="level">L4</td>
            <td class="rate">70mins</td>
            <td class="rate">58%</td>
            <td class="rate">220</td>
          </tr>
          <tr>
            <td class="level">L5</td>
            <td class="rate">90mins</td>
            <td class="rate">60%</td>
            <td class="rate">230</td>
          </tr>
          <tr>
            <td class="level">L6</td>
            <td class="rate">120mins</td>
            <td class="rate">62%</td>
            <td class="rate">240</td>
          </tr>
          <tr>
            <td class="level">L7</td>
            <td class="rate">180mins</td>
            <td class="rate">65%</td>
            <td class="rate">250</td>
          </tr>
        </template>
      </div>

      <div class="notes">
        <div class="tit">{{ $t('lang.LevelRatio.k001') }}</div>
        <div>{{ $t('lang.LevelRatio.k002') }}</div>
        <div>{{ $t('lang.LevelRatio.k003') }}</div>
        <div>{{ $t('lang.LevelRatio.k004') }}</div>
        <div>{{ $t('lang.LevelRatio.k005') }}</div>
        <div>{{ $t('lang.LevelRatio.k006') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchUserAccountInfo } from '@/api/imee.js'

export default {
  data() {
    return {
      code: null
    }
  },
  methods: {
    fetchUserAccountInfo() {
      apiFetchUserAccountInfo().then((res) => {
        this.code = res.locationCode
      })
    }
  },
  created() {
    this.fetchUserAccountInfo()
  }
}
</script>
<style lang="scss" scoped>
.container-help {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    // line-height: 20px;
    .table {
      width: 100%;
      // height: 306px;
      background: #ffffff;
      box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      margin-bottom: 12px;
      th {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        // height: 62px;
        background: #f2f3f8;
        font-size: 12px;
        font-family: 'Inter-Bold', 'Inter-Regular';
        font-weight: 800;
        color: #333333;
        padding: 10px 0;
        > div {
          height: 42px;
        }
      }
      .th1 {
        border-radius: 8px 0 0 0;
      }
      .th4 {
        border-radius: 0 8px 0 0;
        span {
          display: block;
          font-size: 12px;
          font-family: 'Inter-Regular';
          font-weight: 400;
          color: #333333;
          transform: scale(1);
        }
      }
      tr {
        display: flex;
        justify-content: space-between;
      }
      td {
        height: 55px;
        line-height: 55px;
        font-size: 14px;
        font-family: 'Inter-Regular';
        font-weight: 400;
        color: #333333;
      }
      .level {
        flex: 1;
        width: 40px;
        text-align: center;
      }
      .earning {
        width: 180px;
        text-align: center;
      }
      .rate {
        width: 95px;
        text-align: center;
      }
    }
    .notes {
      margin: 30px 0 0 0;
      font-size: 14px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      .tit {
        font-size: 14px;
        font-family: 'Inter-Bold', 'Inter-Regular';
        font-weight: 600;
        color: #333333;
        line-height: 26px;
      }
      .iclass {
        color: #333333;
      }
    }
  }
}
</style>
